import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Navbar } from "./components/Navbar";
import { ErrorBoundary } from "./components/ErrorBoundary";

import PublicForm from "./pages/PublicForm";
import AdminLogin from "./pages/AdminLogin";
import Dashboard from "./pages/Dashboard";
import PatientList from "./pages/PatientList";
import AddPatient from "./pages/AddPatient";
import PatientDetail from "./pages/PatientDetail";
import PrintableFisa from "./pages/PrintableFisa";
import PrintableProvizorie from "./pages/PrintableProvizorie";
import RaportAntrenori from "./pages/RaportAntrenori";

// Layout pentru toate rutele admin protejate (includes Navbar)
function AdminLayout({ children }) {
  return (
    <ProtectedRoute>
      <div className="min-h-screen bg-background">
        <Navbar />
        <main>{children}</main>
      </div>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
          {/* Public — formular înscriere pacient + buton ADMIN */}
          <Route path="/" element={<PublicForm />} />

          {/* Admin login (neprotejat dar redirect dacă deja logat) */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Rute admin protejate */}
          <Route path="/admin/dashboard" element={<AdminLayout><Dashboard /></AdminLayout>} />
          <Route path="/admin/patients" element={<AdminLayout><PatientList /></AdminLayout>} />
          <Route path="/admin/patients/:id" element={<AdminLayout><PatientDetail /></AdminLayout>} />
          {/* Fișă tip pentru completare manuală — pagină print-friendly, fără AdminLayout */}
          <Route path="/admin/patients/:id/fisa-tip-print" element={<ProtectedRoute><PrintableFisa /></ProtectedRoute>} />
          {/* Aviz medico-sportiv provizoriu — pagină print-friendly */}
          <Route path="/admin/patients/:id/provizorie-print" element={<ProtectedRoute><PrintableProvizorie /></ProtectedRoute>} />
          <Route path="/admin/add-patient" element={<AdminLayout><AddPatient /></AdminLayout>} />
          <Route path="/admin/raport-antrenori" element={<AdminLayout><RaportAntrenori /></AdminLayout>} />

          {/* Compat: rute vechi → redirect la /admin/* */}
          <Route path="/patients" element={<Navigate to="/admin/patients" replace />} />
          <Route path="/patients/:id" element={<RedirectToAdminPatient />} />
          <Route path="/add-patient" element={<Navigate to="/admin/add-patient" replace />} />
          <Route path="/dashboard" element={<Navigate to="/admin/dashboard" replace />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
    </ErrorBoundary>
  );
}

// Mic helper pentru a păstra :id la redirect-ul vechi
function RedirectToAdminPatient() {
  const path = window.location.pathname.replace(/^\/patients\//, "/admin/patients/");
  return <Navigate to={path} replace />;
}

export default App;
